import { useEffect } from "react";
import { Autocomplete, Grid, MenuItem, Select, TextField } from "../../../../components";
import { value } from "../../../../helpers";
import FiltroImpressaoGrupoProduto from "./filtro-impressao-grupo-produto.component";
import FiltroImpressaoNfEntrada from "./filtro-impressao-nf-entrada.component";
import FiltroImpressaoProduto from "./filtro-impressao-produto.component";
import { EtiquetasService } from "../../../../services";

const etiquetasService = new EtiquetasService();

const FiltroImpressaoStep = ({
  etiqueta,
  setEtiqueta,
  listaEtiquetas,
  setListaEtiquetas,
  nfEntrada,
  setNfEntrada,
  listaOpcoesNfEntrada,
  setListaOpcoesNfEntrada,
  produtoSelecionado,
  setProdutoSelecionado,
  filtroImpressao,
  setFiltroImpressao,
  listaOpcoesProdutos,
  setListaOpcoesProdutos,
  inputErros
}) => {

  const showAbaFiltroImpressao = () => {
    switch (filtroImpressao?.tipoFiltro) {
      case 'grupoProduto': 
        return (
        <FiltroImpressaoGrupoProduto 
          filtroImpressao={filtroImpressao}
          setFiltroImpressao={setFiltroImpressao}
          inputErros={inputErros}
        />)
      case 'nfEntrada': 
        return (
        <FiltroImpressaoNfEntrada
          nfEntrada={nfEntrada}
          setNfEntrada={setNfEntrada}
          listaOpcoesNfEntrada={listaOpcoesNfEntrada}
          setListaOpcoesNfEntrada={setListaOpcoesNfEntrada}
          setFiltroImpressao={setFiltroImpressao}
          inputErros={inputErros}
        />)
      default: 
        return (
        <FiltroImpressaoProduto
          produtoSelecionado={produtoSelecionado}
          setProdutoSelecionado={setProdutoSelecionado}
          listaOpcoesProdutos={listaOpcoesProdutos}
          setListaOpcoesProdutos={setListaOpcoesProdutos}
          setFiltroImpressao={setFiltroImpressao}
          inputErros={inputErros}
        />)
    }
  }

  const handleSelectChange = (e) => {
    inputErros.limpar();
    setFiltroImpressao((prevState) => ({
      ...prevState,
      tipoFiltro: e.target.value,
    }));
  }

  useEffect(() => {
    buscarEtiquetas();
  }, []);

  const buscarEtiquetas = async function () {
    const filtros = { nonPaginated: true };
    etiquetasService.getAll(filtros).then((result) => {
      if (!result.isAxiosError) {
        setListaEtiquetas(result.data);
      } else {
        setListaEtiquetas([]);
      }
    });
  };

  return (
    <>
    <Grid container spacing={2} sx={{ mt: 4, mb: 2 }}>
      <Grid item xs={6}>
        <Select
          label="Filtrar Por"
          name="tipoFiltro"
          id="tipoFiltro"
          margin="none"
          variant="outlined"
          disableClearable
          onChange={handleSelectChange}
          value={value.text(filtroImpressao?.tipoFiltro)}
          InputLabelProps={{ shrink: true }}
        >
          <MenuItem value={"produto"}>Produto</MenuItem>
          <MenuItem value={"grupoProduto"}>Grupo de Produtos</MenuItem>
          <MenuItem value={"nfEntrada"}>NF Entrada</MenuItem>
        </Select>
      </Grid>
      <Grid item xs={6}>
        <Autocomplete
          required
          id="etiquetaId"
          name="etiquetaId"
          options={listaEtiquetas}
          noOptionsText="Sem opções"
          autoHighlight
          getOptionLabel={(option) =>
            option?.descricao
              ? option.descricao
              : ""
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label="Modelo de Etiqueta"
              margin="none"
              required
              InputProps={{
                ...params.InputProps,
              }}
              error={inputErros.get("etiquetaId")}
            />
          )}
          onChange={(e, value) => setEtiqueta(value)}
          value={value.autoComplete(listaEtiquetas, etiqueta?.id)}
        />
      </Grid>
    </Grid>
    <Grid container spacing={2}>
      {showAbaFiltroImpressao()}
    </Grid>
    </>
  );
};

export default FiltroImpressaoStep;
